
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reference-customers",
      function () {
        return require("private-next-pages/reference-customers/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reference-customers"])
      });
    }
  